/*
 * @Author: your name
 * @Date: 2021-09-08 11:34:29
 * @LastEditTime: 2025-02-11 14:46:22
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \baishu_react_ui\src\utils\http.js
 */
// request.js

import React from 'react';

import langCN from '../language/zh_cn';
import axios from 'axios';
import tipAlert from '../Login/BsyAlertTip/Staticize';
import { BsyUtils } from './Utils';

import { CacheUtils } from './cacheUtils.js';

const instance = axios.create({ //创建axios实例，在这里可以设置请求的默认配置
    timeout: 0,

})

//初始化post请求的几种'Content-Type'
instance.defaults.headers.post['Content-Type'] = 'application/json'
instance.defaults.headers.post['X-CSRF-Token'] = window.sitesetting.csrf_token;
instance.defaults.headers.post['FRAME-TYPE'] = "REACT";

/** 添加请求拦截器 **/
instance.interceptors.request.use(config => {

    let cacheKey = config.cacheKey;
    if (cacheKey) {

        CacheUtils.cache[cacheKey] && CacheUtils.clearCache(cacheKey);
        config.cancelToken = new axios.CancelToken(function executor(c) {
            CacheUtils.cache[cacheKey] = c;
        });
    }

    // const method = config.method.toLowerCase();
    // if (['post'].includes(method) && config.data && typeof config.data === 'object') {
    //     cacheKey += [
    //         config.data.hasOwnProperty('appId') ? config.data.appId : '',
    //         config.data.hasOwnProperty('entryId') ? config.data.entryId : '',
    //         config.data.hasOwnProperty('formId') ? config.data.formId : '',
    //         config.data.hasOwnProperty('fastFilter') ? config.data.fastFilter : '',
    //         config.data.hasOwnProperty('hascount') ? config.data.hascount : '',
    //         config.data.hasOwnProperty('field') ? config.data.field : '',
    //         config.data.hasOwnProperty('fields') ? JSON.stringify(config.data.fields) : '',
    //     ].join('');
    // }


    // 临时保存 cacheKey，用于在响应拦截器中清除缓存
    // config.cacheKey = cacheKey;

    return config
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error)
})

/** 添加响应拦截器  **/
instance.interceptors.response.use(response => {
    // 响应接收之后清除缓存
    const cacheKey = response.config.cacheKey;
    delete CacheUtils.cache[cacheKey];
    //正常响应
    return Promise.resolve(response)
}, error => {
    const {
        response
    } = error //关键点 实际error 中已经包含了 response的整个信息
    if (response) {
        const {
            config
        } = response

        if (config) {
            const cacheKey = error.config.cacheKey;
            delete CacheUtils.cache[cacheKey];
        }

        //处理通用错误
        switch (response.status) {
            case 400:

                if (config) {
                    if (config.dashMode === "isFull") {
                        //报表 自动刷新的情况下，忽略接口超出频率的提示
                        if (response.data.code === 400) {
                            if (response.data.msg.indexOf('接口频率超出限制') > -1) {
                                break;
                            }
                        }
                    }
                    if (config) {
                        if (config.autoShowMsg) {
                            break
                        }
                    }

                }

                if (BsyUtils.showAjaxTip(response.data) === true) {

                    response.data.msg ? tipAlert({
                        msg: !langCN[response.data.msg] ? response.data.msg : React.language(response.data.msg),
                        type: "warning"
                    }) : tipAlert({
                        msg: !langCN[response.data.msg] ? response.data.msg : React.language(response.data.msg),
                        type: "error"
                    })
                }
                break;
            case 401:
                tipAlert({
                    msg: React.language("login.expired.again"),
                    type: "warning"
                });
                setTimeout(function () {
                    BsyUtils.redirectTo(window.rootDirectroy + '/user/login')
                }, 2000);
                return
            case 402:
                tipAlert({
                    msg: React.language("error.status.402"),
                    type: "warning"
                });

                break;
            case 403:
                if (config && config.dashMode === "isFull") {
                    //报表 自动刷新的情况下，忽略没有请求权限的错误提示
                    break;
                }
                tipAlert({
                    msg: React.language("error.status.403"),
                    type: "warning"
                });
                break;
            case 404:
                tipAlert({
                    msg: React.language("error.status.404"),
                    type: "warning"
                });
                break;
            case 0:
                break;
            default:
                tipAlert({
                    msg: React.language("error.status.fail"),
                    type: "warning"
                })
                console.error('服务器未知错误', response);
                break;
        }
    }
    return Promise.reject(response)
})

export const get = (url, params, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: 'get',
            url,
            params,

            ...config
        }).then(response => {
            BsyUtils.getServerDate(response);
            resolve(response)
        }).catch(error => {
            BsyUtils.getServerDate(error);
            reject(error)
        })
    }).catch(res => {
        console.error('axios.get', res);
    })
}

export const post = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        if (data) {
            if (data.ignoreAppId !== true) {

                if( !("appId" in data)) {
                    if(window.FX.STATIC.APPID) {
                        data.appId = window.FX.STATIC.APPID
                    } 
                }
                
                if( !( "entryId" in data)) {
                    if(window.FX.STATIC.ENTRYID) {
                        data.entryId = window.FX.STATIC.ENTRYID
                    } 
                }
                
                if ( !( "dataId" in data)) {
                    if (!BsyUtils.isObjectEmpty(window.FX.STATIC.DATAID)) {
                        data.dataId = window.FX.STATIC.DATAID;
                    }
                }
            }
            if (BsyUtils.isEmpty(window.FX.STATIC.DTOKEN)) {
                if (BsyUtils.isEmpty(window.FX.STATIC.FTOKEN)) {
                    if (BsyUtils.isEmpty(window.FX.STATIC.QTOKEN)) {
                        if (BsyUtils.isEmpty(window.FX.STATIC.RTOKEN)) {
                            if (!BsyUtils.isEmpty(window.FX.STATIC.ATOKEN)) {
                                data.fx_access_token = window.FX.STATIC.ATOKEN;
                                data.fx_access_type = "app_public";
                            }
                        } else {
                            data.fx_access_token = window.FX.STATIC.RTOKEN;
                            data.fx_access_type = "report_public"
                        }
                    } else {
                        data.fx_access_token = window.FX.STATIC.QTOKEN;
                        data.fx_access_type = "form_query"
                    }
                } else {
                    data.fx_access_token = window.FX.STATIC.FTOKEN;
                    data.fx_access_type = "form_public"
                }
            } else {
                data.fx_access_token = window.FX.STATIC.DTOKEN;
                data.fx_access_type = "form_public"
            }
            if (window.FX.STATIC.isBackup) {
                data.isBackup = window.FX.STATIC.isBackup;
            }
            if (data.ignoreAppId) {
                delete data.ignoreAppId
            }
            // TODO 需要清除前端自己定义的虚拟权限组
            if (data?.authGroupId === -99) {
                delete data.authGroupId
            }


        }
        if (!!BsyUtils.getParameterByName("dock_corpid")) {
            data = data || {};
            data.dock_corpid = BsyUtils.getParameterByName("dock_corpid");
        }
        if (url.indexOf("http") === -1) {
            url = window.rootDirectroy + url;
        }
        let fData = "";
        let isFormData = false;
        if (data instanceof FormData) {
            isFormData = true;
        } else {
            if (window.paramBase64 && data) {
                fData = `database64=${BsyUtils.Base64Encode(JSON.stringify(data))}`;
            }
            // data = window.paramBase64 ? 'database64:' + BsyUtils.Base64Encode(JSON.stringify(data)) : data;
        }
        instance({
            method: 'post',
            url,
            data: isFormData ? data : window.paramBase64 ? fData : data,
            headers: {
                'Content-Type': isFormData ? "multipart/form-data;" : window.paramBase64 ? 'application/x-www-form-urlencoded;' : 'application/json;charset=UTF-8',
            },
            ...config
        }).then(response => {
            BsyUtils.getServerDate(response);
            resolve(response)
        }).catch(error => {
            BsyUtils.getServerDate(error);
            reject(error)
        })
    })
    // .catch(res => {
    //     console.error('axios.post', JSON.stringify(res));
    // })
}
